import { arbitrum, arbitrumGoerli, avalanche, avalancheFuji, bsc, bscTestnet, crossbell, evmos, evmosTestnet, fantom, fantomTestnet, filecoin, filecoinHyperspace, foundry, gnosis, gnosisChiado, goerli, hardhat, iotex, iotexTestnet, localhost, mainnet, metis, metisGoerli, optimism, optimismGoerli, polygon, polygonMumbai, sepolia, taraxa, taraxaTestnet, zkSync, zkSyncTestnet } from '@wagmi/chains';
import classNames from 'classnames';
import React, { useState, useRef, useEffect, useMemo } from 'react';
import { renderIcon } from '@download/blockies';
import { useEnsAvatar, useEnsName, useNetwork, useAccount, useDisconnect, useSwitchNetwork, useConnect, useSigner } from 'wagmi';
import 'feather-icons-react';
import { ExternalLink, CopyIcon, LinkTheme, BottomSheet, WalletIcon, NetworkIcon, Button, ButtonSize, ButtonTheme, ThemedClipSpinner } from '@pooltogether/react-components';
import { atom, useAtom, useSetAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { shorten } from '@pooltogether/utilities';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { utils, Contract } from 'ethers';
import { toast } from 'react-toastify';
import { v4 } from 'uuid';
import { JsonRpcProvider } from '@ethersproject/providers';
import { MaxUint256 } from '@ethersproject/constants';

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var _Object$freeze;
var WC_RPC_URLS = {};
/**
 * Constant for chain ids
 */

var CHAIN_ID = /*#__PURE__*/Object.freeze({
  'mainnet': 1,
  'homestead': 1,
  'ropsten': 3,
  'rinkeby': 4,
  'goerli': 5,
  'kovan': 42,
  'bsc': 56,
  'poa-sokol': 77,
  'bsc-testnet': 97,
  'poa': 99,
  'xdai': 100,
  'polygon': 137,
  'matic': 137,
  'mumbai': 80001,
  'optimism': 10,
  'optimism-goerli': 420,
  'avalanche': 43114,
  'fuji': 43113,
  'celo': 42220,
  'celo-testnet': 44787,
  'arbitrum': 42161,
  'arbitrum-goerli': 421613
});
/**
 * Custom Wagmi Chains that aren't provided by WAGMI that PoolTogether uses
 */

var CUSTOM_CHAINS = [{
  id: 44787,
  name: 'Celo Alfajores Testnet',
  network: 'Alfajores',
  nativeCurrency: {
    name: 'Celo',
    symbol: 'CELO',
    decimals: 18
  },
  rpcUrls: {
    celohttps: {
      http: ['https://alfajores-forno.celo-testnet.org']
    },
    "default": {
      http: ['https://alfajores-forno.celo-testnet.org']
    },
    "public": {
      http: ['https://alfajores-forno.celo-testnet.org']
    },
    celowss: {
      http: ['wss://alfajores-forno.celo-testnet.org/ws']
    }
  },
  blockExplorers: {
    "default": {
      name: 'BlockScout',
      url: 'https://alfajores-blockscout.celo-testnet.org/'
    }
  },
  testnet: true
}, {
  id: 42220,
  name: 'Celo',
  network: 'Celo',
  nativeCurrency: {
    name: 'Celo',
    symbol: 'CELO',
    decimals: 18
  },
  rpcUrls: {
    forno: {
      http: ['https://forno.celo.org']
    },
    "default": {
      http: ['https://forno.celo.org']
    },
    "public": {
      http: ['https://forno.celo.org']
    }
  },
  blockExplorers: {
    "default": {
      name: 'Celo Explorer',
      url: 'https://explorer.celo.org/'
    }
  },
  testnet: false
}, {
  id: 56,
  name: 'Binance Smart Chain',
  network: 'BSC',
  nativeCurrency: {
    decimals: 18,
    name: 'Binance Chain Native Token',
    symbol: 'BNB'
  },
  rpcUrls: {
    "default": {
      http: ['https://bsc-dataseed.binance.org/']
    },
    "public": {
      http: ['https://bsc-dataseed.binance.org/']
    },
    bsc1: {
      http: ['https://bsc-dataseed.binance.org/']
    },
    bsc2: {
      http: ['https://bsc-dataseed1.defibit.io/']
    },
    bsc3: {
      http: ['https://bsc-dataseed1.ninicoin.io/']
    }
  },
  blockExplorers: {
    "default": {
      name: 'Bscscan',
      url: 'https://bscscan.com'
    }
  }
}, {
  id: 43114,
  name: 'Avalanche Mainnet',
  network: 'Avalanche',
  nativeCurrency: {
    name: 'Avalanche',
    symbol: 'AVAX',
    decimals: 18
  },
  rpcUrls: {
    "default": {
      http: ['https://api.avax.network/ext/bc/C/rpc']
    },
    "public": {
      http: ['https://api.avax.network/ext/bc/C/rpc']
    }
  },
  blockExplorers: {
    "default": {
      name: 'SnowTrace',
      url: 'https://snowtrace.io'
    }
  },
  testnet: false
}, {
  id: 43113,
  name: 'Avalanche Fuji Testnet',
  network: 'Fuji',
  nativeCurrency: {
    name: 'Avalanche',
    symbol: 'AVAX',
    decimals: 18
  },
  rpcUrls: {
    "default": {
      http: ['https://api.avax-test.network/ext/bc/C/rpc']
    },
    "public": {
      http: ['https://api.avax-test.network/ext/bc/C/rpc']
    }
  },
  blockExplorers: {
    "default": {
      name: 'SnowTrace',
      url: 'https://testnet.snowtrace.io'
    }
  },
  testnet: true
}];
/**
 *
 */

var CHAIN_NAME_OVERRIDE = /*#__PURE__*/Object.freeze((_Object$freeze = {}, _Object$freeze[CHAIN_ID.mainnet] = 'Ethereum', _Object$freeze[CHAIN_ID.avalanche] = 'Avalanche', _Object$freeze[CHAIN_ID.fuji] = 'Fuji', _Object$freeze[CHAIN_ID.polygon] = 'Polygon', _Object$freeze[CHAIN_ID.bsc] = 'Binance Smart Chain', _Object$freeze[CHAIN_ID.celo] = 'Celo', _Object$freeze[CHAIN_ID.xdai] = 'xDai', _Object$freeze));
/**
 * In case we want to inject a public RPC URL for a chain into wagmi Chain objects, we can do that here.
 */

var CHAIN_RPC_OVERRIDES = /*#__PURE__*/Object.freeze({});
/**
 * Overwrites the name of the chain with PoolTogethers preferred name.
 * @param chain
 */

var editChainName = function editChainName(chain) {
  var override = CHAIN_NAME_OVERRIDE[chain.id];
  if (override) chain.name = override;
  return chain;
};
/**
 * Pushes the preferred RPC URLS for the chain with PoolTogethers preferred RPC URL to the front.
 * @param chain
 */


var editRpcUrl = function editRpcUrl(chain) {
  var overrides = CHAIN_RPC_OVERRIDES[chain.id]; //@ts-ignore

  if (overrides) chain.rpcUrls = _extends({}, overrides, chain.rpcUrls);
  return chain;
};
/**
 * Returns a list of all chains from wagmi augmented with PT preferred names and RPC URLs.
 */


var ALL_CHAINS = /*#__PURE__*/[arbitrum, arbitrumGoerli, avalanche, avalancheFuji, bsc, bscTestnet, crossbell, evmos, evmosTestnet, fantom, fantomTestnet, filecoin, filecoinHyperspace, foundry, gnosis, gnosisChiado, goerli, hardhat, iotex, iotexTestnet, localhost, mainnet, metis, metisGoerli, optimism, optimismGoerli, polygon, polygonMumbai, sepolia, taraxa, taraxaTestnet, zkSync, zkSyncTestnet].concat(CUSTOM_CHAINS).map(editChainName).map(editRpcUrl);
/**
 * A transaction is pending until it has either been cancelled, errored or succeeded.
 */

var TransactionState;

(function (TransactionState) {
  TransactionState["pending"] = "pending";
  TransactionState["complete"] = "complete";
})(TransactionState || (TransactionState = {}));
/**
 * A transaction progresses through these states linearly.
 * 1. pendingUserConfirmation
 * 2. pendingBlockchainConfirmation or cancelled
 * 3. success or error
 */


var TransactionStatus;

(function (TransactionStatus) {
  TransactionStatus["pendingUserConfirmation"] = "userConfirming";
  TransactionStatus["pendingBlockchainConfirmation"] = "chainConfirming";
  TransactionStatus["cancelled"] = "cancelled";
  TransactionStatus["success"] = "success";
  TransactionStatus["error"] = "error";
})(TransactionStatus || (TransactionStatus = {}));

var AccountAvatar = function AccountAvatar(props) {
  var address = props.address,
      className = props.className,
      sizeClassName = props.sizeClassName,
      chainId = props.chainId;

  var _useEnsAvatar = useEnsAvatar({
    address: address,
    chainId: chainId
  }),
      src = _useEnsAvatar.data;

  if (src) {
    return /*#__PURE__*/React.createElement("img", {
      src: src,
      className: classNames(className, sizeClassName)
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, sizeClassName)
  }, /*#__PURE__*/React.createElement(BlockieIdenticon, {
    address: address,
    alt: "Ethereum address: " + address
  }));
};
AccountAvatar.defaultProps = {
  sizeClassName: 'w-7 h-7 sm:w-8 sm:h-8',
  className: 'rounded-full overflow-hidden',
  chainId: CHAIN_ID.mainnet
};

var BlockieIdenticon = function BlockieIdenticon(_ref) {
  var address = _ref.address,
      alt = _ref.alt,
      className = _ref.className;

  var _useState = useState(null),
      dataUrl = _useState[0],
      setDataUrl = _useState[1];

  var canvasRef = useRef(null);
  useEffect(function () {
    var canvas = canvasRef.current;
    renderIcon({
      seed: address == null ? void 0 : address.toLowerCase()
    }, canvas);
    var updatedDataUrl = canvas.toDataURL();

    if (updatedDataUrl !== dataUrl) {
      setDataUrl(updatedDataUrl);
    }
  }, [dataUrl, address]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("canvas", {
    ref: canvasRef,
    style: {
      display: 'none'
    }
  }), dataUrl && /*#__PURE__*/React.createElement("img", {
    className: className,
    src: dataUrl,
    alt: alt || ''
  }));
};

BlockieIdenticon.defaultProps = {
  address: undefined,
  alt: '',
  className: ''
};

/**
 * Builds objects with PoolTogether preferred names and RPC urls.
 * @param chainId
 * @returns a WAGMI Chain data type
 */

var getChain = function getChain(chainId) {
  return ALL_CHAINS.find(function (chain) {
    return chain.id === chainId;
  });
};

/**
 *
 * @param chainId chain id that maps to a network alias
 * @returns the name of the chain requested or Unknown if not known
 */

var getChainNameByChainId = function getChainNameByChainId(chainId) {
  var chain = getChain(chainId);

  if (!chain) {
    return 'Unknown';
  }

  return chain.name;
};

/**
 * Transaction we can do something with
 */

var isWalletConnectionModalOpenAtom = /*#__PURE__*/atom(false);
/**
 * Transaction we can do something with
 */

var transactionsAtom = /*#__PURE__*/atomWithStorage('pooltogether-transactions', []);
/**
 * Write only.
 * Creates a transaction in the storage.
 * Limits transaction storage to 20 transactions across all addresses.
 */

var createTransactionsAtom = /*#__PURE__*/atom(null, function (get, set, _transaction) {
  var transactions = [].concat(get(transactionsAtom));

  var transaction = _extends({}, _transaction, {
    state: TransactionState.pending,
    status: TransactionStatus.pendingUserConfirmation
  });

  transactions.push(transaction);

  if (transactions.length > 20) {
    transactions = transactions.slice(transactions.length - 20);
  }

  set(transactionsAtom, transactions);
});
/**
 * Write only.
 * Updates a transactions state, status, response or receipt in the storage.
 * Overwrites some receipt and response data with null to ensure it they fit in local storage.
 */

var updateTransactionsAtom = /*#__PURE__*/atom(null, function (get, set, transactionUpdate) {
  var _transactions$index, _transactions$index2, _transactions$index3, _transactions$index4;

  var id = transactionUpdate.id,
      state = transactionUpdate.state,
      status = transactionUpdate.status,
      response = transactionUpdate.response,
      receipt = transactionUpdate.receipt;
  if (!!receipt) receipt.logs = null;
  if (!!response) response.data = null;
  var transactions = [].concat(get(transactionsAtom));
  var index = transactions.findIndex(function (transaction) {
    return transaction.id === id;
  });
  transactions[index] = _extends({}, transactions[index], {
    state: state || ((_transactions$index = transactions[index]) == null ? void 0 : _transactions$index.state),
    status: status || ((_transactions$index2 = transactions[index]) == null ? void 0 : _transactions$index2.status),
    response: response || ((_transactions$index3 = transactions[index]) == null ? void 0 : _transactions$index3.response),
    receipt: receipt || ((_transactions$index4 = transactions[index]) == null ? void 0 : _transactions$index4.receipt)
  });
  set(transactionsAtom, transactions);
});
/**
 * Write only.
 * Removes a transactions from the storage.
 */

var deleteTransactionsAtom = /*#__PURE__*/atom(null, function (get, set, id) {
  var transactions = [].concat(get(transactionsAtom));
  var index = transactions.findIndex(function (transaction) {
    return transaction.id === id;
  });
  transactions.splice(index, 1);
  set(transactionsAtom, transactions);
});

/**
 *
 * @param usersAddress
 * @returns
 */

var useUsersTransactions = function useUsersTransactions(usersAddress) {
  var _useAtom = useAtom(transactionsAtom),
      transactions = _useAtom[0];

  return transactions.filter(function (transaction) {
    var _transaction$response;

    return transaction.usersAddress === usersAddress && !!((_transaction$response = transaction.response) != null && _transaction$response.hash);
  });
};

var AccountName = function AccountName(props) {
  var address = props.address,
      chainId = props.chainId;

  var _useEnsName = useEnsName({
    address: address,
    chainId: chainId
  }),
      ensName = _useEnsName.data;

  return /*#__PURE__*/React.createElement(React.Fragment, null, ensName || (address == null ? void 0 : address.slice(0, 6)) + '...');
};
AccountName.defaultProps = {
  chainId: CHAIN_ID.mainnet
};

/**
 *
 * @returns the chain id the connected wallet is on
 */

var useWalletChainId = function useWalletChainId() {
  var _useNetwork = useNetwork(),
      chain = _useNetwork.chain;

  return chain == null ? void 0 : chain.id;
};

var getBlockExplorerUrl = function getBlockExplorerUrl(chainId) {
  var _chain$blockExplorers, _chain$blockExplorers2;

  var chain = getChain(chainId);
  return (_chain$blockExplorers = chain.blockExplorers) == null ? void 0 : (_chain$blockExplorers2 = _chain$blockExplorers["default"]) == null ? void 0 : _chain$blockExplorers2.url;
};

var BlockExplorerLink = function BlockExplorerLink(props) {
  var address = props.address,
      txHash = props.txHash,
      children = props.children,
      className = props.className,
      shorten$1 = props.shorten,
      noIcon = props.noIcon,
      noText = props.noText,
      underline = props.underline,
      iconClassName = props.iconClassName,
      copyable = props.copyable,
      chainId = props.chainId,
      theme = props.theme;
  var url;

  if (txHash) {
    url = formatBlockExplorerTxUrl(txHash, chainId);
  } else if (address) {
    url = formatBlockExplorerAddressUrl(address, chainId);
  }

  var display = txHash || address;
  var defaultText = /*#__PURE__*/React.createElement("div", {
    className: 'flex'
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames('inline-block', {
      'sm:hidden': !shorten$1
    })
  }, shorten({
    hash: display,
    "short": true
  })), /*#__PURE__*/React.createElement("span", {
    className: classNames('hidden', {
      'sm:inline-block': !shorten$1
    })
  }, !noText && display));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExternalLink, {
    underline: underline,
    theme: theme,
    className: classNames("inline-flex", className),
    href: url,
    noIcon: noIcon,
    iconClassName: iconClassName,
    title: 'View on Block Explorer'
  }, !noText && (children || defaultText)), copyable && /*#__PURE__*/React.createElement(CopyIcon, {
    className: classNames(className, iconClassName, theme, 'ml-2'),
    text: display
  }));
};
BlockExplorerLink.defaultProps = {
  noIcon: false,
  noText: false,
  underline: false,
  theme: LinkTheme["default"],
  iconClassName: 'h-4 w-4 ml-1'
};
var formatBlockExplorerTxUrl = function formatBlockExplorerTxUrl(tx, chainId) {
  try {
    var blockExplorerUrl = getBlockExplorerUrl(chainId);
    return blockExplorerUrl + "/tx/" + tx;
  } catch (e) {
    console.error('Chain Id not supported', {
      chainId: chainId
    });
    return null;
  }
};
var formatBlockExplorerAddressUrl = function formatBlockExplorerAddressUrl(address, chainId) {
  try {
    var blockExplorerUrl = getBlockExplorerUrl(chainId);
    return blockExplorerUrl + "/address/" + address;
  } catch (e) {
    console.error('Chain Id not supported', {
      chainId: chainId
    });
    return null;
  }
};

var AccountModal = function AccountModal(props) {
  var isOpen = props.isOpen,
      closeModal = props.closeModal;

  var _useAccount = useAccount(),
      address = _useAccount.address,
      connector = _useAccount.connector;

  var _useDisconnect = useDisconnect(),
      disconnect = _useDisconnect.disconnect;

  var connectorName = connector == null ? void 0 : connector.name;
  var chainId = useWalletChainId();
  var transactions = useUsersTransactions(address);
  var filteredTransactions = transactions == null ? void 0 : transactions.slice(transactions.length - 5).reverse();
  var setTransactions = useSetAtom(transactionsAtom);

  if (!address) {
    return /*#__PURE__*/React.createElement(BottomSheet, {
      label: 'account-modal',
      isOpen: isOpen,
      closeModal: closeModal,
      maxWidthClassName: 'xs:max-w-md'
    }, /*#__PURE__*/React.createElement("div", null));
  }

  return /*#__PURE__*/React.createElement(BottomSheet, {
    label: 'account-modal',
    isOpen: isOpen,
    closeModal: closeModal,
    maxWidthClassName: 'xs:max-w-md'
  }, /*#__PURE__*/React.createElement("h4", {
    className: 'mb-2'
  }, "Account"), /*#__PURE__*/React.createElement("div", {
    className: 'grid grid-cols-2'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'flex flex-col space-y-2'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'flex space-x-2 items-center font-bold'
  }, /*#__PURE__*/React.createElement(AccountAvatar, {
    address: address,
    sizeClassName: 'w-8 h-8'
  }), /*#__PURE__*/React.createElement(BlockExplorerLink, {
    className: 'opacity-80',
    shorten: true,
    address: address,
    chainId: chainId,
    copyable: true
  }, /*#__PURE__*/React.createElement(AccountName, {
    address: address
  }))), /*#__PURE__*/React.createElement("div", {
    className: 'space-x-2 opacity-80 flex items-center'
  }, /*#__PURE__*/React.createElement(WalletIcon, {
    wallet: connectorName == null ? void 0 : connectorName.toLowerCase(),
    sizeClassName: 'w-6 h-6',
    className: 'mx-1'
  }), /*#__PURE__*/React.createElement("span", null, connectorName)), /*#__PURE__*/React.createElement("div", {
    className: 'space-x-2 opacity-80 flex items-center'
  }, /*#__PURE__*/React.createElement(NetworkIcon, {
    chainId: chainId,
    sizeClassName: 'w-6 h-6',
    className: 'mx-1'
  }), /*#__PURE__*/React.createElement("span", null, getChainNameByChainId(chainId)), /*#__PURE__*/React.createElement("span", {
    className: 'text-xxs opacity-80'
  }, "(" + chainId + ")"))), /*#__PURE__*/React.createElement("div", {
    className: 'flex flex-col justify-end'
  }, /*#__PURE__*/React.createElement(Button, {
    className: 'w-32 ml-auto',
    size: ButtonSize.sm,
    onClick: function onClick() {
      try {
        closeModal();
        disconnect();
      } catch (e) {
        console.error(e.message);
        window.location.reload();
      }
    },
    theme: ButtonTheme.orangeOutline
  }, "Disconnect"))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    className: 'flex justify-between items-center'
  }, /*#__PURE__*/React.createElement("h5", {
    className: 'mb-2'
  }, "Past Transactions"), filteredTransactions.length > 0 && /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setTransactions([]);
    },
    className: 'opacity-50 text-xxs leading-none'
  }, "Clear transactions")), /*#__PURE__*/React.createElement("ul", {
    className: 'space-y-1'
  }, filteredTransactions.map(function (transaction) {
    return /*#__PURE__*/React.createElement(TransactionItem, {
      key: transaction.id,
      transaction: transaction
    });
  }), filteredTransactions.length === 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: 'opacity-50'
  }, "No transactions yet"))));
};

var TransactionItem = function TransactionItem(props) {
  var transaction = props.transaction;
  return /*#__PURE__*/React.createElement("li", {
    key: transaction.id,
    className: 'flex space-x-2 items-center'
  }, /*#__PURE__*/React.createElement(TransactionStatusIcon, {
    transaction: transaction
  }), !!transaction.response ? /*#__PURE__*/React.createElement(BlockExplorerLink, {
    chainId: transaction.chainId,
    txHash: transaction.response.hash
  }, transaction.name) : /*#__PURE__*/React.createElement("span", null, transaction.name));
};

var TransactionStatusIcon = function TransactionStatusIcon(props) {
  return null;
};

/**
 * Returns transactions that have been submitted by the user to be mined that are still pending
 * @param usersAddress
 * @returns
 */

var useUsersPendingTransactions = function useUsersPendingTransactions(usersAddress) {
  var _useAtom = useAtom(transactionsAtom),
      transactions = _useAtom[0];

  return transactions.filter(function (transaction) {
    return transaction.usersAddress === usersAddress && transaction.status === TransactionStatus.pendingBlockchainConfirmation;
  });
};

var NetworkSelectionList = function NetworkSelectionList(props) {
  var chains = props.chains,
      onSwitch = props.onSwitch;

  var _useAccount = useAccount(),
      connector = _useAccount.connector;

  var _useNetwork = useNetwork(),
      activeChain = _useNetwork.chain;

  var _useSwitchNetwork = useSwitchNetwork(),
      _switchNetwork = _useSwitchNetwork.switchNetwork;

  var walletChainId = useWalletChainId();

  var _useState = useState(),
      switchingToNetwork = _useState[0],
      setSwitchingToNetwork = _useState[1];

  var _useState2 = useState(),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var switchNetwork = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(chainId) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setErrorMessage(undefined);

              if (!(walletChainId !== chainId)) {
                _context.next = 12;
                break;
              }

              _context.prev = 2;
              setSwitchingToNetwork(chainId);
              _context.next = 6;
              return _switchNetwork(chainId);

            case 6:
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);
              setErrorMessage("Error switching to " + getChainNameByChainId(chainId));

            case 12:
              setSwitchingToNetwork(undefined);
              onSwitch == null ? void 0 : onSwitch(chainId);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 8]]);
    }));

    return function switchNetwork(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  if (!connector) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: 'space-y-2 mx-auto max-w-sm'
  }, chains.map(function (chain) {
    return /*#__PURE__*/React.createElement(NetworkSelectionButton, {
      key: chain.id,
      chain: chain,
      onClick: function onClick() {
        return switchNetwork(chain.id);
      },
      pending: switchingToNetwork === chain.id,
      selected: activeChain.id === chain.id
    });
  })), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: 'text-pt-red-light pt-2 text-xxs'
  }, errorMessage));
};

var NetworkSelectionButton = function NetworkSelectionButton(props) {
  var chain = props.chain,
      pending = props.pending,
      selected = props.selected,
      onClick = props.onClick;
  var id = chain.id,
      name = chain.name;
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    className: classNames('bg-pt-purple-lighter dark:bg-pt-purple-darker rounded-lg p-4 flex items-center w-full transition-colors', 'border', {
      'hover:border-highlight-1': !pending,
      'border-default': selected,
      'border-transparent': !selected
    }),
    disabled: pending
  }, /*#__PURE__*/React.createElement(NetworkIcon, {
    chainId: id,
    className: 'mx-1',
    sizeClassName: 'w-5 h-5'
  }), /*#__PURE__*/React.createElement("span", {
    className: 'capitalize leading-none tracking-wider font-bold text-lg'
  }, name), pending && /*#__PURE__*/React.createElement(ThemedClipSpinner, {
    sizeClassName: 'w-5 h-5 ml-2'
  })));
};

var NetworkSelectionCurrentlySelected = function NetworkSelectionCurrentlySelected(props) {
  var t = props.t;

  var _useNetwork = useNetwork(),
      chain = _useNetwork.chain;

  return /*#__PURE__*/React.createElement("div", {
    className: 'mt-2 flex flex-col space-y-2 text-center'
  }, /*#__PURE__*/React.createElement("p", {
    className: 'text-xxxs'
  }, (t == null ? void 0 : t('currentlyConnectedTo')) || 'Currently connected to', /*#__PURE__*/React.createElement("b", {
    className: classNames('ml-1', {
      'text-pt-red-light': chain.unsupported
    })
  }, chain.name || getChainNameByChainId(chain.id))));
};

var NetworkSelectionModal = function NetworkSelectionModal(props) {
  var chains = props.chains,
      isOpen = props.isOpen,
      closeModal = props.closeModal,
      t = props.t;
  return /*#__PURE__*/React.createElement(BottomSheet, {
    label: 'wallet-connection-modal',
    isOpen: isOpen,
    closeModal: closeModal,
    maxWidthClassName: 'xs:max-w-md'
  }, /*#__PURE__*/React.createElement("h6", {
    className: 'text-center uppercase text-sm mb-3'
  }, (t == null ? void 0 : t('chooseANetwork')) || 'Choose a network'), /*#__PURE__*/React.createElement("p", {
    className: 'max-w-xs mx-auto text-xs mb-8 text-center'
  }, "Select a network to switch to or change manually in your wallet."), /*#__PURE__*/React.createElement(NetworkSelectionList, {
    chains: chains,
    onSwitch: closeModal
  }), /*#__PURE__*/React.createElement(NetworkSelectionCurrentlySelected, {
    t: t
  }));
};

var getChainColorByChainId = function getChainColorByChainId(chainId) {
  switch (chainId) {
    case CHAIN_ID.mainnet:
      return '#68a7ff';

    case CHAIN_ID.goerli:
    case CHAIN_ID.kovan:
    case CHAIN_ID.rinkeby:
      return '#ff9303';

    case CHAIN_ID['bsc-testnet']:
    case CHAIN_ID.bsc:
      return '#d7a42f';

    case CHAIN_ID.polygon:
    case CHAIN_ID.mumbai:
      return '#946fdf';

    case CHAIN_ID.optimism:
    case CHAIN_ID['optimism-kovan']:
    case CHAIN_ID['optimism-goerli']:
      return '#EE000B';

    case CHAIN_ID.avalanche:
    case CHAIN_ID.fuji:
      return '#e61b1b';

    case CHAIN_ID.celo:
    case CHAIN_ID['celo-testnet']:
      return '#3ef3d4';

    default:
      return null;
  }
};

var NetworkSelectionButton$1 = function NetworkSelectionButton(props) {
  var chains = props.chains,
      className = props.className,
      sizeClassName = props.sizeClassName,
      t = props.t;

  var _useAccount = useAccount(),
      connector = _useAccount.connector;

  var chainId = useWalletChainId();

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  if (!connector) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: classNames(className, 'flex space-x-2 items-center'),
    onClick: function onClick() {
      return setIsOpen(true);
    }
  }, /*#__PURE__*/React.createElement(NetworkIcon, {
    chainId: chainId,
    sizeClassName: sizeClassName,
    className: 'shadow'
  }), /*#__PURE__*/React.createElement("span", {
    className: "hidden sm:block font-bold hover:opacity-70 transition",
    style: {
      color: getChainColorByChainId(chainId)
    }
  }, getChainNameByChainId(chainId))), /*#__PURE__*/React.createElement(NetworkSelectionModal, {
    closeModal: function closeModal() {
      return setIsOpen(false);
    },
    isOpen: isOpen,
    chains: chains,
    t: t
  }));
};

var WalletConnectionList = function WalletConnectionList(props) {
  var className = props.className,
      onWalletConnected = props.onWalletConnected;

  var _useConnect = useConnect(),
      connectors = _useConnect.connectors,
      connect = _useConnect.connect;

  var _useState = useState(),
      pendingConnector = _useState[0],
      setPendingConnector = _useState[1];

  var _useState2 = useState(),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _connectWallet = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(connector) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setPendingConnector(connector);
              _context.prev = 1;
              connect({
                connector: connector
              });
              onWalletConnected == null ? void 0 : onWalletConnected();
              _context.next = 11;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              console.error('Error connecting to wallet');
              setErrorMessage('Error connecting to wallet');
              return _context.abrupt("return");

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    }));

    return function connectWallet(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: classNames('space-y-2 mx-auto', className)
  }, connectors.filter(function (connector) {
    return connector.id !== 'walletConnect';
  }).map(function (connector) {
    return /*#__PURE__*/React.createElement(FullWalletConnectionButton, {
      key: connector.id,
      connector: connector,
      connectWallet: function connectWallet() {
        return _connectWallet(connector);
      },
      disabled: !!pendingConnector,
      pending: pendingConnector === connector
    });
  })), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: 'text-pt-red-light pt-2 text-xxs'
  }, errorMessage));
};

var FullWalletConnectionButton = function FullWalletConnectionButton(props) {
  var connector = props.connector,
      connectWallet = props.connectWallet,
      disabled = props.disabled,
      pending = props.pending;
  var name = connector.name,
      ready = connector.ready;
  if (!ready) return null;
  var isInjected = connector.id === 'injected';
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    onClick: connectWallet,
    className: classNames('space-x-2 bg-pt-purple-lightest dark:bg-pt-purple-darkest rounded-lg p-4 flex items-center w-full transition-colors hover:border-highlight-1', 'border', {
      'border-default': pending,
      'border-transparent': !pending
    }),
    disabled: disabled
  }, /*#__PURE__*/React.createElement(WalletIcon, {
    wallet: isInjected ? 'injected' : name.toLowerCase(),
    className: 'ml-4',
    sizeClassName: 'w-6 h-6'
  }), /*#__PURE__*/React.createElement("span", {
    className: 'capitalize leading-none tracking-wider font-bold text-lg'
  }, isInjected ? 'injected' : name), pending && /*#__PURE__*/React.createElement(ThemedClipSpinner, {
    sizeClassName: 'w-5 h-5 ml-2'
  })));
};

var WalletConnectionModal = function WalletConnectionModal(props) {
  var isOpen = props.isOpen,
      TosDisclaimer = props.TosDisclaimer,
      closeModal = props.closeModal;
  return /*#__PURE__*/React.createElement(BottomSheet, {
    label: 'wallet-connection-modal',
    isOpen: isOpen,
    closeModal: closeModal,
    widthClassName: 'w-screen xs:w-full',
    maxWidthClassName: 'xs:max-w-md',
    roundedClassName: 'rounded-none xs:rounded-xl',
    header: 'Connect to a wallet'
  }, /*#__PURE__*/React.createElement(WalletConnectionModalContent, {
    TosDisclaimer: TosDisclaimer,
    onWalletConnected: closeModal
  }));
};
var WalletConnectionModalContent = function WalletConnectionModalContent(props) {
  var TosDisclaimer = props.TosDisclaimer,
      onWalletConnected = props.onWalletConnected,
      className = props.className;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: 'mb-8'
  }, TosDisclaimer), /*#__PURE__*/React.createElement(WalletConnectionList, {
    className: classNames('mb-4', className),
    onWalletConnected: onWalletConnected
  }), /*#__PURE__*/React.createElement("a", {
    className: 'text-pt-teal transition hover:opacity-70 underline text-sm',
    href: 'https://ethereum.org/en/wallets/',
    target: '_blank',
    rel: 'noreferrer'
  }, "What's a wallet?"));
};

/**
 * NOTE: Only render one per app.
 * @param props
 * @returns
 */

var FullWalletConnectionButton$1 = function FullWalletConnectionButton(props) {
  var chains = props.chains,
      className = props.className,
      buttonClassName = props.buttonClassName,
      iconSizeClassName = props.iconSizeClassName,
      pendingIconSizeClassName = props.pendingIconSizeClassName,
      t = props.t,
      theme = props.theme,
      TosDisclaimer = props.TosDisclaimer;

  var _useAccount = useAccount(),
      address = _useAccount.address,
      connector = _useAccount.connector;

  var _useState = useState(false),
      isAccountModalOpen = _useState[0],
      setIsAccountModalOpen = _useState[1];

  var _useAtom = useAtom(isWalletConnectionModalOpenAtom),
      isWalletConnectionModalOpen = _useAtom[0],
      setIsWalletConnectionModalOpen = _useAtom[1];

  var pendingTransactions = useUsersPendingTransactions(address);
  var connected = !!connector;
  var networkButton;
  var button = /*#__PURE__*/React.createElement(ConnectButton.Custom, null, function (_ref) {
    var openConnectModal = _ref.openConnectModal,
        mounted = _ref.mounted;
    var ready = mounted;
    return /*#__PURE__*/React.createElement("div", Object.assign({}, !ready && {
      'aria-hidden': true,
      'style': {
        opacity: 0,
        pointerEvents: 'none',
        userSelect: 'none'
      }
    }), /*#__PURE__*/React.createElement(Button, {
      className: classNames(buttonClassName),
      onClick: openConnectModal,
      size: ButtonSize.sm,
      theme: theme
    }, (t == null ? void 0 : t('connectWallet')) || 'Connect Wallet'));
  });

  if ((pendingTransactions == null ? void 0 : pendingTransactions.length) > 0) {
    networkButton = /*#__PURE__*/React.createElement(NetworkSelectionButton$1, {
      chains: chains
    });
    button = /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setIsAccountModalOpen(true);
      },
      className: classNames(buttonClassName, 'flex text-gradient-magenta hover:text-inverse transition-colors font-semibold items-center space-x-2')
    }, /*#__PURE__*/React.createElement(ThemedClipSpinner, {
      sizeClassName: pendingIconSizeClassName
    }), /*#__PURE__*/React.createElement("span", null, pendingTransactions.length + " pending"));
  } else if (connected && !!address) {
    networkButton = /*#__PURE__*/React.createElement(NetworkSelectionButton$1, {
      chains: chains,
      sizeClassName: iconSizeClassName
    });
    button = /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return setIsAccountModalOpen(true);
      },
      className: classNames(buttonClassName, 'flex text-gradient-magenta hover:text-inverse transition-colors font-semibold items-center space-x-2')
    }, /*#__PURE__*/React.createElement(AccountAvatar, {
      address: address,
      sizeClassName: iconSizeClassName,
      className: 'shadow rounded-full overflow-hidden'
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(AccountName, {
      address: address
    })));
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: className
  }, networkButton, button), /*#__PURE__*/React.createElement(AccountModal, {
    t: t,
    closeModal: function closeModal() {
      return setIsAccountModalOpen(false);
    },
    isOpen: isAccountModalOpen,
    TosDisclaimer: TosDisclaimer
  }), /*#__PURE__*/React.createElement(WalletConnectionModal, {
    t: t,
    closeModal: function closeModal() {
      return setIsWalletConnectionModalOpen(false);
    },
    isOpen: isWalletConnectionModalOpen,
    TosDisclaimer: TosDisclaimer
  }));
};
FullWalletConnectionButton$1.defaultProps = {
  className: 'flex space-x-4 items-center',
  iconSizeClassName: 'w-6 h-6',
  pendingIconSizeClassName: 'w-4 h-4',
  theme: ButtonTheme.teal
};

var TransactionToastStatus;

(function (TransactionToastStatus) {
  TransactionToastStatus["pendingUserConfirmation"] = "pendingUserConfirmation";
  TransactionToastStatus["pending"] = "pending";
  TransactionToastStatus["cancelled"] = "cancelled";
  TransactionToastStatus["success"] = "success";
  TransactionToastStatus["error"] = "error";
})(TransactionToastStatus || (TransactionToastStatus = {}));

var TransactionToast = function TransactionToast(props) {
  var message = props.message,
      _status = props.status,
      chainId = props.chainId,
      hash = props.hash,
      t = props.t;
  var status = getStatus(_status, t);
  return /*#__PURE__*/React.createElement("div", {
    className: 'flex flex-col font-averta'
  }, /*#__PURE__*/React.createElement("div", null, message), /*#__PURE__*/React.createElement("div", {
    className: 'flex space-x-1 opacity-80'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'text-xxxs'
  }, status), hash && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: 'text-xxxs'
  }, "|"), /*#__PURE__*/React.createElement(BlockExplorerLink, {
    className: 'text-xxxs',
    chainId: chainId,
    txHash: hash,
    shorten: true
  }, (t == null ? void 0 : t('receipt')) || 'Receipt'))));
};

var getStatus = function getStatus(status, t) {
  if (status === TransactionToastStatus.pendingUserConfirmation) {
    return (t == null ? void 0 : t('pendingWalletConfirmation')) || 'Pending wallet confirmation';
  } else if (status === TransactionToastStatus.pending) {
    return (t == null ? void 0 : t('pendingBlockchainConfirmation')) || 'Pending blockchain confirmation';
  } else if (status === TransactionToastStatus.cancelled) {
    return (t == null ? void 0 : t('cancelled')) || 'Cancelled';
  } else if (status === TransactionToastStatus.success) {
    return (t == null ? void 0 : t('success')) || 'Success';
  } else if (status === TransactionToastStatus.error) {
    return (t == null ? void 0 : t('theWordError')) || 'Error';
  }
};

/**
 * Sets the boolean controlling the WalletConnectionModal to true.
 * useConnectWallet Relies on having the WalletConnectionModal mounted elsewhere in the app.
 * @returns
 */

var useConnectWallet = function useConnectWallet() {
  var setIsWalletConnectionModalOpen = useSetAtom(isWalletConnectionModalOpenAtom);
  return function () {
    return setIsWalletConnectionModalOpen(true);
  };
};

/**
 *
 * @param chainId chain id to match against the wallets chain id
 * @returns true if wallet chain id matches, false otherwise
 */

var useIsWalletOnChainId = function useIsWalletOnChainId(chainId) {
  var walletChainId = useWalletChainId();
  return chainId === walletChainId;
};

/**
 * Checks if a wallet is connected
 * @returns
 */

var useIsWalletConnected = function useIsWalletConnected() {
  var _useAccount = useAccount(),
      address = _useAccount.address,
      status = _useAccount.status;

  return !!address && status === 'connected';
};

/**
 * Checksums the address for easier checks throughout the app.
 * @returns the address of the connected wallet
 */

var useUsersAddress = function useUsersAddress() {
  var _useAccount = useAccount(),
      address = _useAccount.address;

  return useMemo(function () {
    return !!address ? utils.getAddress(address) : null;
  }, [address]);
};

var useIsWalletMetamask = function useIsWalletMetamask() {
  var _useConnect = useConnect(),
      data = _useConnect.data;

  return (data == null ? void 0 : data.connector.name) === 'MetaMask';
};

/**
 *
 * @param id
 * @returns
 */

var useTransaction = function useTransaction(id) {
  var _useAtom = useAtom(transactionsAtom),
      transactions = _useAtom[0];

  return transactions.find(function (transaction) {
    return transaction.id === id;
  });
};

/**
 *
 * @param id
 * @returns
 */

var useTransactions = function useTransactions(ids) {
  var _useAtom = useAtom(transactionsAtom),
      transactions = _useAtom[0];

  return transactions.filter(function (transaction) {
    return ids == null ? void 0 : ids.includes(transaction.id);
  });
};

/**
 * @param log optional error logger
 * @returns
 */

var useSendTransaction = function useSendTransaction(t, log) {
  var usersAddress = useUsersAddress();
  var chainId = useWalletChainId();
  var createTransaction = useSetAtom(createTransactionsAtom);
  var updateTransaction = useSetAtom(updateTransactionsAtom);
  /**
   * Submits the transaction, updates state and executes callbacks.
   * @param id
   * @param name
   * @param chainId
   * @param usersAddress
   * @param callTransaction
   * @param callbacks
   */

  var sendTransaction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(id, name, chainId, callTransaction, callbacks) {
      var response, receipt, responsePromise, receiptPromise, status, _e$message, _e$error, _receipt, _receipt2, errorDetails, errorMessage, _receipt3, _errorMessage;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              callbacks == null ? void 0 : callbacks.onSentToWallet == null ? void 0 : callbacks.onSentToWallet(id);
              responsePromise = callTransaction();
              toast.promise(responsePromise, {
                pending: {
                  render: function render() {
                    return /*#__PURE__*/React.createElement(TransactionToast, {
                      message: name,
                      chainId: chainId,
                      status: TransactionToastStatus.pendingUserConfirmation,
                      t: t
                    });
                  }
                }
              });
              _context.next = 6;
              return responsePromise;

            case 6:
              response = _context.sent;

              // Chain id may be set to 0 if EIP-155 is disabled and legacy signing is used
              // See https://docs.ethers.io/v5/api/utils/transactions/#Transaction
              if (response.chainId === 0) {
                response.chainId = chainId;
              } // Transaction was confirmed in users wallet


              updateTransaction({
                id: id,
                response: response,
                status: TransactionStatus.pendingBlockchainConfirmation
              });
              callbacks == null ? void 0 : callbacks.onConfirmedByUser == null ? void 0 : callbacks.onConfirmedByUser(id);
              receiptPromise = response.wait();
              toast.promise(receiptPromise, {
                pending: {
                  render: function render() {
                    return /*#__PURE__*/React.createElement(TransactionToast, {
                      message: name,
                      chainId: chainId,
                      status: TransactionToastStatus.pending,
                      t: t
                    });
                  }
                },
                success: {
                  render: function render(props) {
                    var data = props.data;
                    return /*#__PURE__*/React.createElement(TransactionToast, {
                      message: name,
                      chainId: chainId,
                      status: TransactionToastStatus.success,
                      hash: data == null ? void 0 : data.transactionHash,
                      t: t
                    });
                  }
                },
                error: {
                  render: function render(props) {
                    var data = props.data;
                    return /*#__PURE__*/React.createElement(TransactionToast, {
                      message: name,
                      chainId: chainId,
                      status: TransactionToastStatus.error,
                      hash: data == null ? void 0 : data.transactionHash,
                      t: t
                    });
                  }
                }
              });
              _context.next = 14;
              return receiptPromise;

            case 14:
              receipt = _context.sent;
              // Transaction was confirmed on chain
              callbacks == null ? void 0 : callbacks.onComplete == null ? void 0 : callbacks.onComplete(id);
              status = !!receipt.status && receipt.status === 1 ? TransactionStatus.success : TransactionStatus.error;
              updateTransaction({
                id: id,
                receipt: receipt,
                status: status,
                state: TransactionState.complete
              });

              if (status === TransactionStatus.success) {
                callbacks == null ? void 0 : callbacks.onSuccess == null ? void 0 : callbacks.onSuccess(id);
              } else {
                callbacks == null ? void 0 : callbacks.onError == null ? void 0 : callbacks.onError(id);
              }

              callbacks == null ? void 0 : callbacks.refetch == null ? void 0 : callbacks.refetch(id);
              _context.next = 26;
              break;

            case 22:
              _context.prev = 22;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0, _context.t0.message);

              if (_context.t0 != null && (_e$message = _context.t0.message) != null && _e$message.match('User denied transaction signature')) {
                updateTransaction({
                  id: id,
                  status: TransactionStatus.cancelled,
                  state: TransactionState.complete
                });
                toast.error( /*#__PURE__*/React.createElement(TransactionToast, {
                  message: name,
                  chainId: chainId,
                  status: TransactionToastStatus.cancelled,
                  hash: (_receipt = receipt) == null ? void 0 : _receipt.transactionHash,
                  t: t
                }));
              } else if (_context.t0 != null && (_e$error = _context.t0.error) != null && _e$error.message) {
                errorDetails = getErrorDetails(_context.t0.error.message);
                updateTransaction({
                  id: id,
                  receipt: receipt,
                  status: TransactionStatus.error,
                  state: TransactionState.complete
                });
                errorMessage = "Transaction failed - " + errorDetails;
                toast.error( /*#__PURE__*/React.createElement(TransactionToast, {
                  message: errorMessage,
                  chainId: chainId,
                  status: TransactionToastStatus.cancelled,
                  hash: (_receipt2 = receipt) == null ? void 0 : _receipt2.transactionHash,
                  t: t
                }));
                log == null ? void 0 : log(errorMessage);
              } else {
                updateTransaction({
                  id: id,
                  receipt: receipt,
                  status: TransactionStatus.error,
                  state: TransactionState.complete
                });
                _errorMessage = "Transaction failed - Unknown error";
                toast.error( /*#__PURE__*/React.createElement(TransactionToast, {
                  message: _errorMessage,
                  chainId: chainId,
                  status: TransactionToastStatus.cancelled,
                  hash: (_receipt3 = receipt) == null ? void 0 : _receipt3.transactionHash,
                  t: t
                }));
                log == null ? void 0 : log(_errorMessage);
              }

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 22]]);
    }));

    return function sendTransaction(_x, _x2, _x3, _x4, _x5) {
      return _ref.apply(this, arguments);
    };
  }();

  return function (options) {
    var name = options.name,
        callTransaction = options.callTransaction,
        callbacks = options.callbacks;
    var id = v4();
    createTransaction({
      id: id,
      name: name,
      chainId: chainId,
      usersAddress: usersAddress
    });
    sendTransaction(id, name, chainId, callTransaction, callbacks);
    return id;
  };
};

var getErrorDetails = function getErrorDetails(errorMessage) {
  if (errorMessage.includes('Ticket/twab-burn-lt-balance')) return 'Insufficient ticket balance';
  if (errorMessage.includes('TWABDelegator/lock-too-long')) return 'Lock is too long';
  return errorMessage;
};

/**
 * @param log optional error logger
 * @returns
 */

var useSendTransactions = function useSendTransactions(t, log) {
  var sendTransaction = useSendTransaction(t, log);
  return function (optionsList) {
    return optionsList.map(function (options, index) {
      options.name += " (" + (index + 1) + "/" + optionsList.length + ")";
      return sendTransaction(options);
    });
  };
};

/**
 * @param log optional error logger
 * @returns
 */

var useSendSequentialTransactions = function useSendSequentialTransactions(transactionsList, t, log) {
  var sendTransaction = useSendTransaction(t, log);

  var sendIndexedTransaction = function sendIndexedTransaction(index) {
    var options = _extends({}, transactionsList[index]);

    options.name += " (" + (index + 1) + "/" + transactionsList.length + ")";
    var isLast = index === transactionsList.length - 1;
    if (!options.callbacks) options.callbacks = {};

    if (!isLast) {
      var _options$callbacks;

      var tempOnConfirmedByUser = (_options$callbacks = options.callbacks) == null ? void 0 : _options$callbacks.onConfirmedByUser;

      options.callbacks.onConfirmedByUser = function (id) {
        tempOnConfirmedByUser == null ? void 0 : tempOnConfirmedByUser(id);
        sendIndexedTransaction(index + 1);
      };
    }

    sendTransaction(options);
  };

  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", sendIndexedTransaction(0));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

var _Object$freeze$1;
var PROXY_RPC_URL = /*#__PURE__*/Object.freeze((_Object$freeze$1 = {}, _Object$freeze$1[CHAIN_ID.mainnet] = 'https://ethereum-mainnet-web3-provider-proxy.pooltogether-api.workers.dev/', _Object$freeze$1[CHAIN_ID.goerli] = 'https://goerli-web3-provider-proxy.pooltogether-api.workers.dev/', _Object$freeze$1[CHAIN_ID.optimism] = 'https://optimism-mainnet-web3-provider-proxy.pooltogether-api.workers.dev/', _Object$freeze$1[CHAIN_ID['optimism-goerli']] = 'https://optimism-goerli-web3-provider-proxy.pooltogether-api.workers.dev/', _Object$freeze$1[CHAIN_ID.arbitrum] = 'https://arbitrum-web3-provider-proxy.pooltogether-api.workers.dev/', _Object$freeze$1[CHAIN_ID['arbitrum-goerli']] = 'https://arbitrum-goerli-web3-provider-proxy.pooltogether-api.workers.dev/', _Object$freeze$1[CHAIN_ID.polygon] = 'https://polygon-mainnet-web3-provider-proxy.pooltogether-api.workers.dev/', _Object$freeze$1[CHAIN_ID.mumbai] = 'https://polygon-mumbai-web3-provider-proxy.pooltogether-api.workers.dev/', _Object$freeze$1[CHAIN_ID.fuji] = 'https://avalanche-fuji-web3-provider-proxy.pooltogether-api.workers.dev/', _Object$freeze$1[CHAIN_ID.avalanche] = 'https://avalanche-mainnet-web3-provider-proxy.pooltogether-api.workers.dev/', _Object$freeze$1));
/**
 * Builds a list of RPC URLs for the given chainId.
 * @param chainId
 * @param rpcUrl will be first in the list of RPC URLs
 */

var getRpcUrls = function getRpcUrls(chainId, rpcUrl) {
  var _getChain, _getChain$rpcUrls;

  var rpcUrls = []; // Passthrough for overriding

  if (!!rpcUrl) {
    if (typeof rpcUrl === 'string') {
      rpcUrls.push(rpcUrl);
    } else {
      rpcUrls.push.apply(rpcUrls, rpcUrl);
    }
  } // Add initialized RPC URLs


  var storedRpcUrl = WC_RPC_URLS[chainId];

  if (storedRpcUrl) {
    if (typeof storedRpcUrl === 'string') {
      rpcUrls.push(storedRpcUrl);
    } else {
      rpcUrls.push.apply(rpcUrls, storedRpcUrl);
    }
  } // // PT Proxied RPC URLs
  // if (!!PROXY_RPC_URL[chainId]) rpcUrls.push(PROXY_RPC_URL[chainId])
  // wagmi public RPC URLs


  var publicRpcUrl = (_getChain = getChain(chainId)) == null ? void 0 : (_getChain$rpcUrls = _getChain.rpcUrls) == null ? void 0 : _getChain$rpcUrls["default"];
  if (!!publicRpcUrl) rpcUrls.push(publicRpcUrl.http[0]);
  return rpcUrls;
};

/**
 * Creates a new Fallback RPC provider for the given chainId.
 * Optionally, can be passed an RPC URL to use instead of the public one.
 * @param chainId
 * @param _rpcUrl
 * @returns
 */

var getReadProvider = function getReadProvider(chainId, _rpcUrl) {
  var rpcUrls = getRpcUrls(chainId, _rpcUrl);
  if (!rpcUrls || rpcUrls.length === 0) throw new Error("No RPC URL found for chainId: " + chainId);
  return new JsonRpcProvider(rpcUrls[0], chainId); // TODO: Add fallback provider for other RPC URLs
  // return new FallbackProvider(
  //   rpcUrls.map((rpcUrl, index) => ({
  //     provider: new JsonRpcProvider(rpcUrl, chainId),
  //     priority: index < 3 ? index + 1 : 3,
  //     weight: index < 2 ? 5 : 1,
  //     stallTimeout: 2000
  //   }))
  // )
};

/**
 * Only call this hook once at the root of the app.
 */

var useUpdateStoredPendingTransactions = function useUpdateStoredPendingTransactions(_rpcUrls) {
  var _useAtom = useAtom(transactionsAtom),
      _transactions = _useAtom[0];

  var updateTransaction = useSetAtom(updateTransactionsAtom);
  var deleteTransaction = useSetAtom(deleteTransactionsAtom);
  useEffect(function () {
    var pendingTransactions = _transactions.filter(function (transaction) {
      return transaction.state === TransactionState.pending;
    });

    pendingTransactions.forEach( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(transaction) {
        var _transaction$response;

        var hash, provider, id, receipt, response, status;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                hash = (_transaction$response = transaction.response) == null ? void 0 : _transaction$response.hash;
                provider = getReadProvider(transaction.chainId, _rpcUrls == null ? void 0 : _rpcUrls[transaction.chainId]);
                id = transaction.id;
                _context.prev = 3;

                if (!hash) {
                  _context.next = 17;
                  break;
                }

                _context.next = 7;
                return provider.getTransaction(hash);

              case 7:
                response = _context.sent;
                _context.next = 10;
                return response.wait();

              case 10:
                _context.next = 12;
                return provider.getTransactionReceipt(hash);

              case 12:
                receipt = _context.sent;
                status = !!receipt.status && receipt.status === 1 ? TransactionStatus.success : TransactionStatus.error;
                updateTransaction({
                  id: id,
                  response: response,
                  receipt: receipt,
                  status: status,
                  state: TransactionState.complete
                });
                _context.next = 18;
                break;

              case 17:
                // Otherwise it is a transaction that never made it to the transaction pool, so it's useless data
                deleteTransaction(id);

              case 18:
                _context.next = 23;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context["catch"](3);
                updateTransaction({
                  id: id,
                  response: response,
                  receipt: receipt,
                  status: TransactionStatus.error,
                  state: TransactionState.complete
                });

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 20]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }, []);
};

var ERC20 = [{
  constant: true,
  inputs: [],
  name: 'name',
  outputs: [{
    name: '',
    type: 'string'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  constant: false,
  inputs: [{
    name: 'spender',
    type: 'address'
  }, {
    name: 'value',
    type: 'uint256'
  }],
  name: 'approve',
  outputs: [{
    name: '',
    type: 'bool'
  }],
  payable: false,
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  constant: true,
  inputs: [],
  name: 'totalSupply',
  outputs: [{
    name: '',
    type: 'uint256'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  constant: false,
  inputs: [{
    name: 'from',
    type: 'address'
  }, {
    name: 'to',
    type: 'address'
  }, {
    name: 'value',
    type: 'uint256'
  }],
  name: 'transferFrom',
  outputs: [{
    name: '',
    type: 'bool'
  }],
  payable: false,
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  constant: true,
  inputs: [],
  name: 'decimals',
  outputs: [{
    name: '',
    type: 'uint8'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  constant: false,
  inputs: [{
    name: 'spender',
    type: 'address'
  }, {
    name: 'addedValue',
    type: 'uint256'
  }],
  name: 'increaseAllowance',
  outputs: [{
    name: '',
    type: 'bool'
  }],
  payable: false,
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  constant: false,
  inputs: [{
    name: 'to',
    type: 'address'
  }, {
    name: 'value',
    type: 'uint256'
  }],
  name: 'mint',
  outputs: [{
    name: '',
    type: 'bool'
  }],
  payable: false,
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  constant: true,
  inputs: [{
    name: 'owner',
    type: 'address'
  }],
  name: 'balanceOf',
  outputs: [{
    name: '',
    type: 'uint256'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  constant: true,
  inputs: [],
  name: 'symbol',
  outputs: [{
    name: '',
    type: 'string'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  constant: false,
  inputs: [{
    name: 'account',
    type: 'address'
  }],
  name: 'addMinter',
  outputs: [],
  payable: false,
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  constant: false,
  inputs: [],
  name: 'renounceMinter',
  outputs: [],
  payable: false,
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  constant: false,
  inputs: [{
    name: 'spender',
    type: 'address'
  }, {
    name: 'subtractedValue',
    type: 'uint256'
  }],
  name: 'decreaseAllowance',
  outputs: [{
    name: '',
    type: 'bool'
  }],
  payable: false,
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  constant: false,
  inputs: [{
    name: 'to',
    type: 'address'
  }, {
    name: 'value',
    type: 'uint256'
  }],
  name: 'transfer',
  outputs: [{
    name: '',
    type: 'bool'
  }],
  payable: false,
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  constant: true,
  inputs: [{
    name: 'account',
    type: 'address'
  }],
  name: 'isMinter',
  outputs: [{
    name: '',
    type: 'bool'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  constant: false,
  inputs: [{
    name: 'sender',
    type: 'address'
  }],
  name: 'initialize',
  outputs: [],
  payable: false,
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  constant: true,
  inputs: [{
    name: 'owner',
    type: 'address'
  }, {
    name: 'spender',
    type: 'address'
  }],
  name: 'allowance',
  outputs: [{
    name: '',
    type: 'uint256'
  }],
  payable: false,
  stateMutability: 'view',
  type: 'function'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: 'account',
    type: 'address'
  }],
  name: 'MinterAdded',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: 'account',
    type: 'address'
  }],
  name: 'MinterRemoved',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: 'from',
    type: 'address'
  }, {
    indexed: true,
    name: 'to',
    type: 'address'
  }, {
    indexed: false,
    name: 'value',
    type: 'uint256'
  }],
  name: 'Transfer',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    name: 'owner',
    type: 'address'
  }, {
    indexed: true,
    name: 'spender',
    type: 'address'
  }, {
    indexed: false,
    name: 'value',
    type: 'uint256'
  }],
  name: 'Approval',
  type: 'event'
}];

var useApproveErc20 = function useApproveErc20(chainId, tokenAddress, spenderAddress, options, amountUnformatted, t, log) {
  if (options === void 0) {
    options = {};
  }

  if (amountUnformatted === void 0) {
    amountUnformatted = MaxUint256;
  }

  var sendTx = useSendTransaction(t, log);

  var _useSigner = useSigner({
    chainId: chainId
  }),
      refetch = _useSigner.refetch;

  var callTransaction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$refetch, signer, erc20, gasEstimate, overrides;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return refetch();

            case 2:
              _yield$refetch = _context.sent;
              signer = _yield$refetch.data;
              erc20 = new Contract(tokenAddress, ERC20, signer);
              _context.next = 7;
              return erc20.estimateGas.approve(spenderAddress, amountUnformatted);

            case 7:
              gasEstimate = _context.sent;
              overrides = !!gasEstimate ? {
                gasLimit: gasEstimate.mul(12).div(10)
              } : undefined;

              if (!overrides) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return", erc20.approve(spenderAddress, amountUnformatted, overrides));

            case 11:
              return _context.abrupt("return", erc20.approve(spenderAddress, amountUnformatted));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function callTransaction() {
      return _ref.apply(this, arguments);
    };
  }();

  return function () {
    var _options;

    return sendTx(_extends({}, options, {
      name: ((_options = options) == null ? void 0 : _options.name) || (t == null ? void 0 : t('approve')) || 'Approve',
      callTransaction: callTransaction
    }));
  };
};

/**
 * Memoizes the Fallback provider to maintain state in the future
 * @param chainId
 * @param _rpcUrl
 * @returns
 */

var useReadProvider = function useReadProvider(chainId, _rpcUrl) {
  return useMemo(function () {
    return getReadProvider(chainId, _rpcUrl);
  }, [chainId, _rpcUrl]);
};

/**
 * Creates a new JSON RPC provider for the given chainIds.
 * Optionally, can be passed RPC URLs to use instead of the public ones.
 * @param chainIds
 * @param rpcUrls
 * @returns
 */

var getReadProviders = function getReadProviders(chainIds, rpcUrls) {
  return chainIds.reduce(function (readProviders, chainId) {
    readProviders[chainId] = getReadProvider(chainId, rpcUrls == null ? void 0 : rpcUrls[chainId]);
    return readProviders;
  }, {});
};

/**
 * Memoizes the Fallback providers to maintain state in the future
 * @param chainId
 * @param _rpcUrl
 * @returns
 */

var useReadProviders = function useReadProviders(chainIds, _rpcUrls) {
  return useMemo(function () {
    return getReadProviders(chainIds, _rpcUrls);
  }, [chainIds, _rpcUrls]);
};

/**
 * Initializes a global store of RPC URLs to be used.
 * @param rpcUrls
 * @returns
 */

var initRpcUrls = function initRpcUrls(rpcUrls) {
  return Object.keys(rpcUrls).map(Number).map(function (chainId) {
    return WC_RPC_URLS[chainId] = rpcUrls[chainId];
  });
};

/**
 *
 * @param chainId chain id that maps to a network alias
 * @returns the network alias that maps to a provided chain id if known
 */

var getChainAliasByChainId = function getChainAliasByChainId(chainId) {
  var networkKeys = Object.keys(CHAIN_ID);
  return networkKeys.find(function (networkKey) {
    return CHAIN_ID[networkKey] === chainId;
  });
};

/**
 * @param networkAlias alias that maps to a chain id
 * @returns a chain id
 */

var getChainIdByAlias = function getChainIdByAlias(networkAlias) {
  return CHAIN_ID == null ? void 0 : CHAIN_ID[networkAlias];
};

/**
 * Returns multiple RPC URLS using configured API keys if possible.
 * @param chainIds
 * @returns
 */

var getRpcUrlsByChainId = function getRpcUrlsByChainId(chainIds, rpcUrls) {
  return chainIds.reduce(function (rpcUrlsByChainId, chainId) {
    rpcUrlsByChainId[chainId] = getRpcUrls(chainId, rpcUrls[chainId]);
    return rpcUrlsByChainId;
  }, {});
};

export { ALL_CHAINS, AccountAvatar, AccountModal, AccountName, BlockExplorerLink, CHAIN_ID, FullWalletConnectionButton$1 as FullWalletConnectionButton, NetworkSelectionButton$1 as NetworkSelectionButton, NetworkSelectionCurrentlySelected, NetworkSelectionList, NetworkSelectionModal, PROXY_RPC_URL, TransactionState, TransactionStatus, TransactionToast, TransactionToastStatus, WalletConnectionList, WalletConnectionModal, WalletConnectionModalContent, formatBlockExplorerAddressUrl, formatBlockExplorerTxUrl, getChain, getChainAliasByChainId, getChainColorByChainId, getChainIdByAlias, getChainNameByChainId, getReadProvider, getReadProviders, getRpcUrls, getRpcUrlsByChainId, initRpcUrls, useApproveErc20, useConnectWallet, useIsWalletConnected, useIsWalletMetamask, useIsWalletOnChainId, useReadProvider, useReadProviders, useSendSequentialTransactions, useSendTransaction, useSendTransactions, useTransaction, useTransactions, useUpdateStoredPendingTransactions, useUsersAddress, useUsersPendingTransactions, useUsersTransactions, useWalletChainId };
//# sourceMappingURL=wallet-connection.esm.js.map
